import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getActivityList = async (params: object) => {
  return await GET({ url: Api.getActivityList, params, showError: false })
}
